import React from 'react';
import SvgIcon from './SvgIcon';

/**
 * @param {FF.SvgIcon} props
 */
function HospitalIcon(props) {
  return (
    <SvgIcon viewBox="0 0 18 18" title="Hospitals" {...props}>
      <path d="M7.875 14.025H10.125V10.125H14.025V7.875H10.125V3.975H7.875V7.875H3.975V10.125H7.875V14.025ZM1.5 18C1.1 18 0.75 17.85 0.45 17.55C0.15 17.25 0 16.9 0 16.5V1.5C0 1.1 0.15 0.75 0.45 0.45C0.75 0.15 1.1 0 1.5 0H16.5C16.9 0 17.25 0.15 17.55 0.45C17.85 0.75 18 1.1 18 1.5V16.5C18 16.9 17.85 17.25 17.55 17.55C17.25 17.85 16.9 18 16.5 18H1.5ZM1.5 16.5H16.5V1.5H1.5V16.5ZM1.5 1.5V16.5V1.5Z" />
    </SvgIcon>
  );
}

export default HospitalIcon;
